module.exports = __webpack_public_path__ + "media/images/flags/16/Australia-3db6b3d951d9162a158a27b0c23c2fb0.png";